import React, { useState } from "react";
import Button from "../../../components/Buttons/Button";
import ItemRevisionCard from "../../../components/Card/ItemRevisionCard3";
import Title from "../../../components/Headers/Title";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemRevisionModel from "../../../models/ItemRevisionModel";
import ItemSearchResult from "../../../models/ItemSearchResult";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import ItemSearchMiniView from "../../Search/ItemMini";
import SelectProjectItemsControl from "../Components/SelectProjectItemsControl";


const AddItemToMultipleBillOfMaterials: React.FC<ProjectPopupProps> = ({ show, onHide, projectId, projectTypeId }) => {
    const [selectedItems, setSelectedItems] = useState<ItemRevisionModel[]>([])
    const [selectedItemRevisions, setSelectedItemRevisions] = useState<ItemSearchResult[]>([])
    const [showSelectedItemsOnly, setShowSelectedItemsOnly] = useState(false)
    const [showSelectItems, setShowSelectItems] = useState(true)
    const [showSpinner, setShowSpinner] = useState(false)
    const { handleResult, handleException } = useNotifications();

    function handleItemClicked(itemRevision: ItemSearchResult) {
        setShowSelectItems(true)
        setSelectedItemRevisions(x => [...x, itemRevision])
    }

    function removeItem(itemRevision: ItemSearchResult) {
        setSelectedItemRevisions(x => x.filter(y => y.itemRevisionId !== itemRevision.itemRevisionId))
    }

    function onSelectedItemsChanges(selectedItems: ItemRevisionModel[]) {
        setSelectedItems(selectedItems)
    }

    function submit() {
        if (selectedItemRevisions.length > 0 && selectedItems.length > 0) {
            setShowSpinner(true)
            for (let i = 0; i < selectedItemRevisions.length; i++) {
                DataService
                    .post<Result>(`api/v1/ItemRevisions/${selectedItemRevisions[i].itemRevisionId}/AddToMultipleBOMs`, selectedItems.map(x => x.defaultBomId))
                    .then(response => {
                        handleResult(response);
                        if (i === selectedItemRevisions.length - 1) {
                            setShowSpinner(false)
                            if (response.isSuccesful === true && onHide) {
                                onHide();
                            }
                        }
                    })
                    .catch(e => { handleException(e); setShowSpinner(false); });
            }
        }
    }

    var cards = selectedItemRevisions.map(item => <ItemRevisionCard itemRevision={item} handleItemClicked={removeItem} /> )

    return <>
        <Popup show={show} onHide={onHide} size={'xxl'} title={'Add Item to Multiple Bill-of-Materials'} >
            <Popup.Body>
                {showSelectItems && selectedItemRevisions.length > 0 &&
                    <div style={{ marginTop: 12 }}>
                        <Title size={4} text="Item to Add to the selected Bill-of-materials" />
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'start' }}>
                            {cards}
                        </div>
                        {showSelectItems && <Button type='button' onClick={() => { setShowSelectItems(false) }} text='Select another item' />}
                    </div>
                }
                {showSelectItems && <div style={{ marginTop: 12 }}><Title size={4} text="Select Bill-of-Materials" /></div>}
                <SelectProjectItemsControl show={showSelectItems} itemsUrl={`api/v1/ItemRevisions/ByProject/${projectId}`} onSelectedItemChanges={onSelectedItemsChanges} showSelectedOnly={showSelectedItemsOnly} formData={{ projectId: projectId, taskId: 0, itemRevisionIds:[] }} />
                {!showSelectItems && <div style={{ marginTop: 12 }}><ItemSearchMiniView handleItemClicked={handleItemClicked} forBom={true} /></div>}
            </Popup.Body>
            <Popup.Footer>
                {showSelectItems && selectedItemRevisions.length > 0 && <Button type='button' onClick={() => { submit() }} text='Add Item' />}
                {showSelectItems && selectedItemRevisions.length == 0 && <Button type='button' onClick={() => { setShowSelectedItemsOnly(true); setShowSelectItems(false);  }} text='Select item' />}
            </Popup.Footer>
        </Popup>
        {showSpinner && <SpinnerOverlay />}
    </>
}
export default AddItemToMultipleBillOfMaterials;